module.exports = __webpack_public_path__ + "img/authourization.2241a30d.svg";